import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import postFun from "@/plugins/postFun.js"; //引入postFun函数
import {
	addCookie,
	getCookie,
	delCookie
} from '@/assets/js/cookie.js';
// import index from '@/pages/web/index'
// import ps1 from '@/pages/web/ps1/index'

Vue.use(Router)

function getAbsolutePath() {
	let path = location.pathname
	return path.substring(0, path.lastIndexOf('/') + 1)
}
const routes = [{
	path: '/',
	name: 'pre',
	component: () => import('@/pages/pre/index')
}]

const router = new Router({
	mode: 'history',
	base: getAbsolutePath(),
	routes
})

function getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURI(r[2]);
	return null;
}

function init() {
	return new Promise(resolve => {
		let token = getCookie('token') || '';

		let p = {
			token: token
		}
		let url = "init";
		postFun.axiosfun(p, url).then((res) => {
			store.commit("changeAllnum", res.data.loadingPage.number);
			store.commit("saveToken", res.data.userInfo.token);
			store.state.drawNumber = res.data.userInfo.drawNumber;
			store.state.task = res.data.userInfo.task;
			resolve(res);
		}).catch((res) => {
			console.log(res);
			resolve(res);
		})
	})
}

function getDanMu() {
	return new Promise(resolve => {
		let token = getCookie('token') || '';

		let p = {
			token: token
		}
		let url = "getDanMu";
		postFun.axiosfun(p, url).then((res) => {
			// console.log(res);
			store.state.danMu = res.data;
			resolve(res);
		}).catch((res) => {
			console.log(res);
			resolve(res);
		})
	})
}

function addGaCode(id){
	const script = document.createElement('script');
		script.src = 'https://www.googletagmanager.com/gtag/js?id='+ id;
		script.async = true;
		document.head.appendChild(script);
		const scriptga = document.createElement('script');
		scriptga.innerHTML ="window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config','"+ id +"');";
		// console.log(scriptga)
		document.head.appendChild(scriptga);
}

function addGaCodeFun(id){
		const scriptga = document.createElement('script');
		scriptga.innerHTML ="function gtag_report_conversion(url) {var callback = function () {if (typeof(url) != 'undefined') {window.location = url;}};gtag('event', 'conversion', {'send_to': '"+ id +"','event_callback': callback});return false;}gtag('event', 'conversion', {'send_to': '"+ id +"'});";
		// console.log(scriptga)
		document.head.appendChild(scriptga);
}



router.beforeEach(async (to, from, next) => {
	await store.dispatch("getlanguageData");
	await init();
	await getDanMu();
	if (getQueryString('ss') == 'Facebook' || getQueryString('ss') == 'sns' || getQueryString('ss') == ''|| getQueryString('ss') == null) {
		const script = document.createElement('script')
		script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1498937057427206');
fbq('track', 'PageView');`
		document.head.appendChild(script)
	}

	if (getQueryString('ss') == 'Tiktok') {
		const script = document.createElement('script')
		script.innerHTML = `
			  !function (w, d, t) {
			    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
			  var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
			  ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
			  
			  
			    ttq.load('CRB7E9BC77U9O5Q9EJC0');
			    ttq.page();
			  }(window, document, 'ttq');`
		document.head.appendChild(script)
	}

	if (to.name === 'pre') {
		addGaCode('G-7131GK1NZE')
	}else if (to.name === 'pre1') {
		addGaCode('G-KWD5SECYX6')
	}else if (to.name === 'pre2') {
		addGaCode('G-Z1GPN2XS19')
	}else if (to.name === 'pre07' || to.name === 'pre07v2') {
		addGaCode('G-PVHTE7S35T')
	}else if (to.name === 'pre08') {
		addGaCode('G-1SR15MM80D')
	}else if (to.name === 'pre09') {
		addGaCode('G-WZYYTE9KK8');
		addGaCodeFun('AW-16660955152/G-nZCPuMwOEZEJCAyIg-');
	}else if (to.name === 'pre10') {
		addGaCode('G-5MY82M2NR3');
		addGaCodeFun('AW-16660955152/G-nZCPuMwOEZEJCAyIg-');
	}

	postFun.iosrefer(to.name)
	next()

})
export default router